import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 50vh;
`;

export const SearchContainer = styled.div`
  padding: 0 0 15px 0;
  border-bottom: 1px solid ${props => props.theme.colors?.border || '#eee'};
  margin-bottom: 10px;
`;

export const ListContainer = styled.div`
  flex: 1;
  width: 550px;
  max-width: 550px;
  overflow-y: auto;
  padding-right: 5px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`;

export const ListItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
`;

export const ItemLabel = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors?.text || '#333'};
  font-weight: 500;
`;

export const ItemPrice = styled.span`
  font-size: 13px;
  color: ${props => props.theme.colors?.textSecondary || '#666'};
  font-weight: 400;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid ${props => props.theme.colors?.border || '#eee'};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const LoadingText = styled.div`
    text-align: center;
    padding: 20px;
    color: ${props => props.theme.colors?.textSecondary || '#666'};
`;

export const EmptyText = styled.div`
    text-align: center;
    padding: 20px;
    color: ${props => props.theme.colors?.textSecondary || '#999'};
    font-style: italic;
`;